

import { Grid, useTheme } from "@mui/material"
import { CardDetalles } from "../components/CardDetalles";
import { LayoutReturn } from "../../../layout";






export const DashboardScreen = () => {


    const theme = useTheme();
    

    const cards = [
      { title:"Perfil", description:"administrar, agregar o eliminar datos para una mejor experiencia.",
          icon:'user', route: '/admin/miperfil', color: theme.palette.primary.main,  key:'1'
      },
      { title:"Mis Documentos", description:"mira y descargar documentos personales de la Empresa.",
          icon: 'photo', route: '', color: theme.palette.secondary.main, key:'2'
      },
      { title:"Seguridad de Cuenta", description:"cambia tu contraseña periodicamente para mejor seguridad.",
          icon: 'password', route: '/admin/cambioclave', color: "#4CAF50", key:'3'
      },
      { title:"Tus Mensajes", description: "ver mensajes de la empresa para un mejor servicio.",
          icon: 'correo', route: '', color: "#FF9800", key:'4'
      },
  ]



    return (

        <LayoutReturn titulo="Mis Opciones">
            <Grid container spacing={3} display="flex" justifyContent="flex-start" mt={1}>
                {cards.map((item) => (
                    <CardDetalles item={item} key={item.key} />
                ))}
            </Grid>
        </LayoutReturn>
    )
}
